import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AppVersionService } from '@insolution/core-data-access';
import { EAvailabilityStatus } from '@insolution/graphql-data-access';
import { AvailabilityService } from '../services/availability.service';

export const availabilityGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AvailabilityService);
  const appVersionService = inject(AppVersionService);
  const router = inject(Router);

  if (appVersionService.isCurrentVersionOutdated()) {
    if (state.url === '/availability') {
      return true;
    }

    await router.navigate(['/availability']);
    return false;
  }

  const availability = await authService.getAvailability(route.data['appType']);

  const isAccessible =
    availability?.status === EAvailabilityStatus.Online || availability?.status === EAvailabilityStatus.AllowedIp;

  if (state.url === '/availability') {
    if (isAccessible) {
      await router.navigate(['/']);
      return false;
    }

    return true;
  } else {
    if (!isAccessible) {
      await router.navigate(['/availability']);

      return false;
    }

    return true;
  }
};
